import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('hg-card')
export class HgCard extends LitElement {
  static styles = css`
    :host {
      display: block;
      background: var(--hg-white);
      border: 1px solid var(--hg-line);
      border-radius: 14px;
      color: var(--hg-ink);
      overflow: hidden;
      box-shadow: var(--md-sys-elevation-1);
    }
    :host([elevated]) {
      box-shadow: var(--md-sys-elevation-1);
    }
    :host([outlined]) {
      box-shadow: none;
    }
    :host([tonal]) {
      background: var(--hg-paper-2);
      box-shadow: none;
    }
    :host([padded]) .body {
      padding: 18px;
    }
    .body {
      min-height: 100%;
    }
  `;

  @property({ type: Boolean, reflect: true }) elevated = false;
  @property({ type: Boolean, reflect: true }) outlined = false;
  @property({ type: Boolean, reflect: true }) tonal = false;
  @property({ type: Boolean, reflect: true }) padded = false;

  render() {
    return html`<div class="body"><slot></slot></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hg-card': HgCard;
  }
}
